import { render } from "./PostCategoryTable.vue?vue&type=template&id=4ccb6d45"
import script from "./PostCategoryTable.vue?vue&type=script&lang=js"
export * from "./PostCategoryTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__